import { createSlice } from "@reduxjs/toolkit";

export const slice = createSlice({
  name: "cache",
  initialState: {
    places: null,
    holidays: null,
    events: null,
    calendars: null,
  },
  reducers: {
    setPlaces: (state, action) => {
      state.places = action.payload;
    },
    setHolidays: (state, action) => {
      state.holidays = action.payload;
    },
    setEvents: (state, action) => {
      state.events = action.payload;
    },
    setCalendars: (state, action) => {
      state.calendars = action.payload;
    },
  },
});

export const { setPlaces, setHolidays, setEvents, setCalendars } =
  slice.actions;

export default slice.reducer;
